import { triggerMaintenance } from '../contexts/MaintenanceContext';

export const CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
};

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function authHeaders(includeContentType = true, extra = {}) {
  const token =
    getCookie('quikr_access_token') ||
    localStorage.getItem('quikr_access_token');

  const headers = token
    ? { Authorization: `Bearer ${token}`, ...extra }
    : { ...extra };

 
  if (includeContentType && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
}

export async function authFetch(url, options = {}) {
  const token =
    getCookie('quikr_access_token') ||
    localStorage.getItem('quikr_access_token');

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), options.timeout || 120000);

  const fetchOptions = {
    ...options,
    headers: authHeaders(false, options.headers || {}),
    signal: controller.signal,
  };

  if (token) {
    fetchOptions.headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, fetchOptions);

    if (response.status === 503) {
      try {
        const clonedResponse = response.clone();
        const data = await clonedResponse.json();
        if (data.maintenance === true) {
          triggerMaintenance(data.message || '');
        }
      } catch {
        triggerMaintenance('');
      }
      return response;
    }

    if (response.status === 401) {
      localStorage.removeItem('quikr_access_token');
      localStorage.removeItem('quikr_email_verified');
      document.cookie = 'quikr_access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      const currentPath = window.location.pathname + window.location.search;
      const redirectParam = encodeURIComponent(currentPath);
      const requiresAuth = window.location.pathname.startsWith('/dashboard');
      if (requiresAuth && !window.location.pathname.startsWith('/login')) {
        window.location.assign(
          `/login?redirect=${redirectParam}&message=${encodeURIComponent('Votre session a expiré. Veuillez vous reconnecter.')}`
        );
      }
    }
    return response;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('La requête a expiré.');
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
}


